import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Complaint from '../components/complaints/complaints-list'
import dataLoad from '../actions/data-load';
import clearComplaints from '../actions/clear-complaints';

function mapStateToProps(state) {
    //  console.log("state are >>>>>", state)
  return {
    user: state.user,
    complaintList: state.complaints ,
    uploading: state.ajaxStatuses.addProofOfPay === 'PENDING',
    complaintsYear: state.complaintYears,
    ajaxDataLoadStatuses: state.ajaxStatuses.dataLoad,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dataLoad,
    clearComplaints,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Complaint);



